import React from 'react';

import '../css/QuantityCircle.less';

const QuantityCircle = (props) => {
    if (props.quantity <= 0 || props.maxiumumQuantity < props.quantity) return null;
    let top = props.quantity;
    let bottom = 'eftir';
    const useText = props.quantity <= 5 && props.quantity >= 3;
    if (useText && process.env.REACT_APP_STORE === 'store1') {
        top = 'Að';
        bottom = 'klárast';
    }
    return (
        <div className={'low-quantity'} style={useText ? { fontSize: 15 } : {}}>
            <div className={'inner-circle'} />
            {top}
            <br />
            {bottom}
        </div>
    );
};

export default QuantityCircle;
